module.exports = __webpack_public_path__ + "img/spitter-run-4.837ba552.png";